import { observable } from '@legendapp/state';

interface DragOverlayStore {
	isDragOverlayVisible: boolean;
	isDragAnimationFinished: boolean;
}

export const dragOverlayStore = observable<DragOverlayStore>({
	isDragOverlayVisible: true,
	isDragAnimationFinished: false
});

export const dragOverlayStoreActions = {
	setIsDragOverlayVisible: (bool: boolean) => {
		dragOverlayStore.isDragOverlayVisible.set(bool);
	},
	setIsDragAnimationFinished: (bool: boolean) => {
		dragOverlayStore.isDragAnimationFinished.set(bool);
	}
};
